import {
    AmountEditorButtonsContainerStyled,
    AmountEditorDescriptionStyled,
    AmountEditorErrorStyled,
    AmountEditorStyled,
} from "./styled/AmountEditorStyled";
import PresetButton from "../PresetButton/PresetButton";
import ContentEditable from "react-contenteditable";
import React, { useCallback } from "react";
import { Form } from "react-bootstrap";
import { KEY_CODES } from "../../app/appConstants";

function AmountEditor(props) {
    const {
        className,
        editMainAmount = true,
        error,
        description,
        label,
        mainAmountBlurHandler,
        mainAmountChangeHandler,
        mainAmountLabel,
        mainAmountPostfix = '',
        mainAmountPrefix = '',
        mainAmountValue = '',
        minusDisabled,
        onButtonClick,
        plusDisabled,
        secondaryAmountBlurHandler,
        secondaryAmountChangeHandler,
        secondaryAmountLabel,
        secondaryAmountPostfix = '',
        secondaryAmountPrefix = '',
        secondaryAmountValue = '',
        switchAmountHandler,
    } = props;

    const keyDownHandler = useCallback((e) => {
        if (e.keyCode === KEY_CODES.ENTER) {
            e.preventDefault();
        }
    }, []);

    return <AmountEditorStyled className={className}>
        <Form.Label>
            <span className="amount-editor-label">{label}</span>
            {
                !!switchAmountHandler && <span className={'at'} onClick={switchAmountHandler}>
                {editMainAmount ? secondaryAmountLabel : mainAmountLabel}
            </span>
            }
        </Form.Label>
        <div className={'amount-row'}>
            <div className={'amount'}>
                {
                    editMainAmount ? <>
                            {mainAmountPrefix}
                            <ContentEditable className={'editable px-2'}
                                             onBlur={mainAmountBlurHandler}
                                             onChange={mainAmountChangeHandler}
                                             onKeyDown={keyDownHandler}
                                             inputMode={'decimal'}
                                             html={mainAmountValue.toString()}/>{mainAmountPostfix}
                        </>
                        :
                        <>
                            {secondaryAmountPrefix}
                            <ContentEditable className={'editable px-2'}
                                             onBlur={secondaryAmountBlurHandler}
                                             onChange={secondaryAmountChangeHandler}
                                             onKeyDown={keyDownHandler}
                                             inputMode={'decimal'}
                                             html={secondaryAmountValue.toString()}/>{secondaryAmountPostfix}
                        </>
                }
            </div>
            <AmountEditorButtonsContainerStyled>
                <PresetButton
                    big
                    disabled={minusDisabled}
                    icon={'IcMinus'}
                    onClick={onButtonClick}
                    value={'minus'}
                />
                <PresetButton
                    big
                    disabled={plusDisabled}
                    icon={'IcPlus'}
                    onClick={onButtonClick}
                    value={'plus'}
                />
            </AmountEditorButtonsContainerStyled>
        </div>
        {
            !error && !!description && <AmountEditorDescriptionStyled>
                {description}
            </AmountEditorDescriptionStyled>
        }
        {
            !!error && <AmountEditorErrorStyled>
                {error}
            </AmountEditorErrorStyled>
        }
    </AmountEditorStyled>
}

export default AmountEditor;
